import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import '../organiserDashboard/Modal.css';
import { ReactComponent as CloseIcon } from '../../images/icons/close.svg';
import SuccessMessage from '../helpers/successMessage';
import ErrorMessage from '../helpers/errorMessage';
import AppContext from '../app/AppContext';
import { isValidEmail } from '../helpers/validationFunctions';
import SmallLoader from '../../images/small_loader.gif';
import { localiseText } from '../../utils';

class AddTeamMemberModal extends Component {
    static contextType = AppContext;

    constructor (props) {
        super(props);

        this.state = {
            currentSuccessMessage: '',
            currentErrorMessage: '',
            firstName: '',
            lastName: '',
            email: '',
            addTeamMemberReadyForSubmission: false,
            loadingButton: false,
            requiresRefresh: false,
        };
    }

    displaySuccessMessage = message => {
        this.setState({
            currentSuccessMessage: message,
        });
    };

    resetSuccessMessage = () => {
        this.setState({
            currentSuccessMessage: '',
        });
    };

    displayErrorMessage = message => {
        this.setState({
            currentErrorMessage: message,
        });
    };

    resetErrorMessage = () => {
        this.setState({
            currentErrorMessage: '',
        });
    };

    handleChange = e => {
        let { value } = e.target;
        if (e.target.name === 'email') {
            value = e.target.value.trim();
        }
        this.setState(
            {
                [e.target.name]: value,
            },
            () => {
                if (this.state.firstName && this.state.lastName) {
                    if (
                        isValidEmail(this.state.email) &&
                        this.state.firstName.length > 1 &&
                        this.state.lastName.length > 1
                    ) {
                        this.setState({
                            addTeamMemberReadyForSubmission: true,
                        });
                    }
                    else {
                        this.setState({
                            addTeamMemberReadyForSubmission: false,
                        });
                    }
                }
            }
        );
    };

    handleAddTeamMemberSubmit = e => {
        if (this.state.addTeamMemberReadyForSubmission) {
            this.setState(
                {
                    loadingButton: true,
                },
                () => {
                    e.preventDefault();
                    const token = this.context.token ? this.context.token : localStorage.getItem('token');
                    const { REACT_APP_API_URL } = process.env;
                    const { id } = this.context.selectedOrganisation;
                    const apiCallURL = `${REACT_APP_API_URL}/api/react/organisations/${id}/invite/`;
                    const headers = {
                        Authorization: `Token ${token}`,
                    };
                    axios
                        .post(
                            apiCallURL,
                            {
                                invitee_first_name: this.state.firstName,
                                invitee_last_name: this.state.lastName,
                                invitee_email: this.state.email,
                            },
                            { headers }
                        )
                        .then(res => {
                            this.setState(
                                {
                                    firstName: '',
                                    lastName: '',
                                    email: '',
                                    addTeamMemberReadyForSubmission: false,
                                    loadingButton: false,
                                    requiresRefresh: true,
                                },
                                () => {
                                    this.displaySuccessMessage(res.data.message);
                                }
                            );
                        })
                        .catch(error => {
                            console.log(error.response);
                            this.setState(
                                {
                                    loadingButton: false,
                                },
                                () => {
                                    this.displayErrorMessage(error.response.data.message);
                                }
                            );
                        });
                }
            );
        }
        else {
            console.log('Add member form validation');
            this.displayErrorMessage('Please make sure all fields are valid');
        }
    };

    render () {
        const {
            firstName,
            lastName,
            email,
            currentSuccessMessage,
            currentErrorMessage,
            addTeamMemberReadyForSubmission,
            loadingButton,
            requiresRefresh,
        } = this.state;
        return (
            <div className="modal-backdrop">
                {currentSuccessMessage && (
                    <SuccessMessage message={currentSuccessMessage} resetSuccessMessage={this.resetSuccessMessage} />
                )}
                {currentErrorMessage && (
                    <ErrorMessage message={currentErrorMessage} resetErrorMessage={this.resetErrorMessage} />
                )}
                <div className="modal-padding" />
                <div className="modal-container">
                    <div className="modal-header">
                        <button
                            className="modal-close-btn"
                            onClick={() => this.props.toggleModal(false, requiresRefresh)}
                        >
                            <CloseIcon />
                        </button>
                        <h2 className="modal-header-title modal-title-no-nav">Invite a new team member</h2>
                    </div>
                    <div className="modal-scrollable">
                        <div className="modal-content">
                            <div className="modal-content-section">
                                <p className="modal-centered-intro">
                                    To invite a team member to your Racecheck {localiseText('organisation')} simply 
                                    submit their details below and we&apos;ll send them a unique invite they can use to join.
                                </p>
                                <form className="log-in-form" onSubmit={this.handleAddTeamMemberSubmit}>
                                    <div className="modal-input-row">
                                        <div className="modal-input-group-half">
                                            <label htmlFor="account-details-first-name" className="modal-input-label">
                                                First name <span className="required-field">*</span>
                                            </label>
                                            <input
                                                id="account-details-first-name"
                                                value={firstName}
                                                onChange={this.handleChange}
                                                className="input modal-input"
                                                name="firstName"
                                                type="text"
                                            />
                                        </div>
                                        <div className="modal-input-group-half">
                                            <label htmlFor="account-details-last-name" className="modal-input-label">
                                                Surname <span className="required-field">*</span>
                                            </label>
                                            <input
                                                id="account-details-last-name"
                                                value={lastName}
                                                onChange={this.handleChange}
                                                className="input modal-input"
                                                name="lastName"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-input-row">
                                        <div className="modal-input-group">
                                            <label htmlFor="account-details-email" className="modal-input-label">
                                                Email address <span className="required-field">*</span>
                                            </label>
                                            <input
                                                id="account-details-email"
                                                value={email}
                                                onChange={this.handleChange}
                                                className="input modal-input"
                                                name="email"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-btn-row">
                                        {loadingButton ? (
                                            <div
                                                role="button"
                                                className={
                                                    `btn sub-fixed-width-btn-small primary-btn modal-form-btn 
                                                    disabled-primary-btn`
                                                }
                                            >
                                                <img
                                                    className="subscription-btn-loader"
                                                    src={SmallLoader}
                                                    alt="userprofile"
                                                />
                                            </div>
                                        ) : (
                                            <div
                                                role="button"
                                                className={`btn sub-fixed-width-btn-small primary-btn modal-form-btn ${
                                                    addTeamMemberReadyForSubmission ? '' : 'disabled-primary-btn'
                                                }`}
                                                onClick={this.handleAddTeamMemberSubmit}
                                            >
                                                Send invite
                                            </div>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-padding" />
            </div>
        );
    }
}

AddTeamMemberModal.propTypes = {
    toggleModal: PropTypes.func.isRequired,
};

AddTeamMemberModal.defaultProps = {
    toggleModal: () => {},
};

export default AddTeamMemberModal;
